// const Partners = () => {
//   const partnersImages = [{title: "1", height: 72, width: 250}, {title: "2", height: 60, width: 370}, {title: "3", height: 108, width: 78}];
//   return (
//     <div className="row align-items-center justify-content-center">
//       {partnersImages.map((item, i) => (
//           <img
//            key={i}
//             className="contain mr20 ml20"
//             src={`/assets/images/partners/${item?.title}.png`}
//             style={{height: item?.height, width: item?.width}}
//             alt="1.png"
//           />
//       ))}
//     </div>
//   );
// };

// export default Partners;
const Partners = ({flexWrap}) => {
  const partnersImages = [
    { title: "1", height: 72, width: 250 },
    { title: "2", height: 60, width: 370 },
    { title: "3", height: 108, width: 78 },
  ];

  return (
    <div id="partners" className={`${flexWrap?"flex-wrap":"flex-noWrap"} partners-container`}>
      {partnersImages.map((item, i) => (
        <img
          id={`partner-img-${item?.title}`}
          key={i}
          className="partner-image"
          src={`/assets/images/partners/${item?.title}.png`}
          alt={`Partner ${item?.title}`}
        />
      ))}
    </div>
  );
};

export default Partners;
